import { useState } from 'react';

/**
 * Emblème Lions Clubs International. Marque déposée : le fichier n'est pas embarqué dans le dépôt,
 * déposez l'emblème officiel (version couleur, fond blanc) dans `apps/web/public/lions-emblem.png`.
 * Sans fichier, rien n'est affiché.
 */
export function Embleme({ grand = false }: { grand?: boolean }) {
  const [absent, setAbsent] = useState(false);
  if (absent) return null;
  return <img src="/lions-emblem.png" alt="Lions Clubs International" className={`embleme${grand ? ' grand' : ''}`} onError={() => setAbsent(true)} />;
}
